import React from 'react'
import { TestSessionPaymentStatus } from '@modmd/data'
import Label, { IndicatorColor } from 'components/Label'

interface StatusLabelModel {
  indicator: keyof typeof IndicatorColor
  label: string
}

interface Props {
  paymentStatus: TestSessionPaymentStatus | null
  invoices?: string | null
  isInvoiceDocNumber?: boolean
}

const getStatusLabelProps = (
  paymentStatus: TestSessionPaymentStatus | null,
  invoices: string | null,
  isInvoiceDocNumber = false
): StatusLabelModel => {
  if (paymentStatus === TestSessionPaymentStatus.OnHold) {
    return {
      indicator: 'yellow',
      label: 'On Hold',
    }
  }
  if (paymentStatus === TestSessionPaymentStatus.Pending) {
    return {
      indicator: 'grayDark',
      label: 'Pending',
    }
  }
  if (paymentStatus === TestSessionPaymentStatus.Paid) {
    return {
      indicator: 'green',
      label: 'Paid',
    }
  }
  if (paymentStatus === TestSessionPaymentStatus.Invoiced) {
    return {
      indicator: 'lightGreen',
      label: `Invoiced ${invoices ? `${isInvoiceDocNumber ? 'NO:' : 'ID:'} ${invoices}` : ''}`,
    }
  }
  if (paymentStatus === TestSessionPaymentStatus.Insurance) {
    return {
      indicator: 'zimaBlue',
      label: 'Insurance',
    }
  }
  if (
    paymentStatus &&
    [TestSessionPaymentStatus.Failed, TestSessionPaymentStatus.Cancelled].includes(paymentStatus)
  ) {
    return {
      indicator: 'red',
      label: paymentStatus,
    }
  }
  return {
    indicator: 'blue',
    label: 'Invoicing',
  }
}

export const TestSessionPaymentLabel: React.VFC<Props> = ({
  paymentStatus,
  invoices = '',
  isInvoiceDocNumber = false,
}) => {
  const statusLabel = getStatusLabelProps(paymentStatus, invoices, isInvoiceDocNumber)
  return (
    <Label size="l" indicator={statusLabel.indicator}>
      {statusLabel.label}
    </Label>
  )
}
